import httpRequest from "~/composables/requset";
import type {ApiResponse, GetPriceInfoResponse} from '~/utils/types';

// 取得訂單列表
export function orderList(data): Promise<ApiResponse> {
    return httpRequest(
        'POST',
        '/api/order/list',
        data
    )
}

// 取消訂單
export function orderCancel(data): Promise<ApiResponse> {
    return httpRequest(
        'POST',
        '/api/order/cancel',
        data
    )
}

//藍新退款
export function newebpayRefund(data): Promise<ApiResponse> {
    return httpRequest(
        'POST',
        '/api/order/newebpay-cancel',
        data
    )

}


// 預訂空間 信用卡付款
export function creditCardReserve(data): Promise<ApiResponse> {
    return httpRequest(
        'POST',
        '/api/order/insto-reserve',
        data
    )
}

// 預訂空間 藍新付款
export function newebpayReserve(spaceId: number, rentType: number, payPrice: number, rentBeginTime: string, rentEndTime: string,
                                carrierId: string, npoban: string, taxIdNumber: string, accessoryIds: number[], estimatedAmount: number,
                                paymentType: number, rentGroup: string): Promise<ApiResponse> {

    const reservationData = {
        "space_id": spaceId,
        "rent_type": rentType,
        "rent_group": rentGroup,
        "amount": payPrice,
        "estimated_amount": estimatedAmount,
        "begin_time": rentBeginTime,
        "end_time": rentEndTime,
        "carrier_id": carrierId,
        "npoban": npoban,
        "tax_id_number": taxIdNumber,
        "accessory_ids": accessoryIds,
        payment_type: paymentType
    }

    return httpRequest(
        'POST',
        '/api/order/newebpay-reserve',
        reservationData
    )
}

// 取得單一訂單資訊
export function getOrderInfo(orderID: string): Promise<ApiResponse> {
    const queryData = {
        order_id: orderID
    }

    return httpRequest(
        'POST',
        '/api/order/info',
        queryData
    )
}

// 取得訂單價格
export function getPrice(spaceId: number, rentType: number, beginTime: string, endTime: string, accessoryIds: number[], rent_group: string): Promise<GetPriceInfoResponse> {
    const queryData = {
        space_id: spaceId,
        rent_type: rentType,
        begin_time: beginTime,
        end_time: endTime,
        accessory_ids: accessoryIds,
        rent_group: rent_group
    }
    return httpRequest(
        'POST',
        '/api/order/get-price',
        queryData
    )
}
